import {
  INIT_URL,
  USER_TOKEN_SET,
  USER_DATA,
  GET_LIST_VAI_TRO
} from "src/constants/ActionTypes";

export const setInitUrl = (url) => {
  return {
    type: INIT_URL,
    payload: url
  };
};

export const setToken = (accessToken) => {
  return {
    type: USER_TOKEN_SET,
    payload: accessToken
  }
};

export const getUserInfo = () => {
  return {
    type: USER_DATA
  }
}

export const getListVaiTro = () => {
  return {
    type: GET_LIST_VAI_TRO
  }
}

